/* Franchitti's Fix: keeps installation (labor) lines tied to their part.
   Labor lines carry _ff_part (part variant id) + _ff_link; the part carries the same _ff_link.
   Price-list adds use _ff_group on both lines. If the part leaves the cart, its labor goes too;
   labor qty never exceeds part qty. Battery labor is free (removed + noted) while same-model screen labor is in the cart. No dependencies. */
(function (root) {
  function linkOf(it) { var p = it.properties || {}; return p._ff_link || p._ff_group || null; }
  function isLabor(it) { var p = it.properties || {}; return !!(p._ff_part || p['Installed at']); }

  /* Pure: returns { lineKey: newQty } for labor lines that must shrink or go. */
  function plan(items) {
    var out = {}, parts = {};
    (items || []).forEach(function (it) {
      if (isLabor(it)) return;
      var k = linkOf(it); if (!k) return;
      parts[k] = parts[k] || { qty: Infinity, ids: {} };
      parts[k].qty = Math.min(parts[k].qty, it.quantity);
      parts[k].ids[String(it.variant_id)] = true;
    });
    (items || []).forEach(function (it) {
      if (!isLabor(it)) return;
      var k = linkOf(it); if (!k) return; /* unlinked labor (manual/legacy): leave alone */
      var want = (it.properties || {})._ff_part, g = parts[k];
      var max = (g && (!want || g.ids[String(want)])) ? g.qty : 0;
      if (it.quantity > max) out[it.key] = max;
    });
    return out;
  }

  /* Screen + battery rule: when screen labor (SKU A01…) for a model is in the cart, battery labor (SKU B01…)
     for the same model is free. The battery labor line is removed and its part carries a note plus
     _ff_bat_labor (labor variant id) so the labor can be restored if the screen leaves the cart. */
  var NOTE = 'Installed with your screen, no extra labor';
  function laborModel(it) { var h = it.handle || ''; return h.indexOf('installation-') === 0 ? h.slice(13) : null; }
  function svc(it) { return String(it.sku || '').slice(0, 3); }
  function screenModels(items) {
    var s = {};
    (items || []).forEach(function (it) { var m = laborModel(it); if (m && svc(it) === 'A01' && it.quantity > 0) s[m] = true; });
    return s;
  }
  function stripNote(props) {
    var o = {}; Object.keys(props || {}).forEach(function (k) { if (k !== '_ff_note' && k !== 'Installation' && k !== '_ff_bat_labor' && k !== '_ff_bat_model') o[k] = props[k]; });
    return o;
  }
  /* Pure: returns { remove: {lineKey: 0}, waive: [{key, quantity, properties}], unwaive: [{key, quantity, properties}], add: [cart/add item] } */
  function planBattery(items) {
    var out = { remove: {}, waive: [], unwaive: [], add: [] }, scr = screenModels(items);
    var byLink = {};
    (items || []).forEach(function (it) { var k = linkOf(it); if (k) (byLink[k] = byLink[k] || []).push(it); });
    (items || []).forEach(function (it) {
      var m = laborModel(it), p = it.properties || {};
      if (!m || svc(it) !== 'B01' || !scr[m] || !isLabor(it)) return;
      var k = linkOf(it); if (!k) return;
      var part = (byLink[k] || []).filter(function (x) { return !isLabor(x) && String(x.variant_id) === String(p._ff_part || x.variant_id); })[0];
      out.remove[it.key] = 0;
      if (part && !(part.properties || {})._ff_bat_labor) {
        var np = stripNote(part.properties); np._ff_note = NOTE; np.Installation = NOTE; np._ff_bat_labor = String(it.variant_id); np._ff_bat_model = m;
        out.waive.push({ key: part.key, quantity: part.quantity, properties: np });
      }
    });
    (items || []).forEach(function (it) {
      var p = it.properties || {}; if (isLabor(it) || !p._ff_bat_labor) return;
      if (scr[p._ff_bat_model]) return; /* screen still there: stays free */
      var k = linkOf(it);
      var hasLabor = (byLink[k] || []).some(function (x) { return isLabor(x); });
      out.unwaive.push({ key: it.key, quantity: it.quantity, properties: stripNote(p) });
      if (!hasLabor) out.add.push({ id: Number(p._ff_bat_labor), quantity: it.quantity, properties: { _ff_link: k, _ff_part: String(it.variant_id), 'Installed at': "Franchitti's Fix" } });
    });
    return out;
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { plan: plan, planBattery: planBattery, NOTE: NOTE }; return; }
  if (root.__ffLink) return; root.__ffLink = true;

  var busy = false, again = false, timer = null, nativeFetch = root.fetch.bind(root);
  function refreshUI() {
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    return nativeFetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var parse = function (h, sel) { var d = new DOMParser().parseFromString(h, 'text/html').querySelector(sel); return d ? d.innerHTML : null; };
      var cd = document.getElementById('CartDrawer'), bub = document.getElementById('cart-icon-bubble');
      if (cd && s['cart-drawer']) { var h = parse(s['cart-drawer'], '#CartDrawer'); if (h !== null) cd.innerHTML = h; }
      if (bub && s['cart-icon-bubble']) { var b = parse(s['cart-icon-bubble'], '.shopify-section'); if (b !== null) bub.innerHTML = b; }
      var el = document.querySelector('cart-drawer'), ov = el && el.querySelector('#CartDrawer-Overlay');
      if (ov && el.close) ov.addEventListener('click', el.close.bind(el));
      return nativeFetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (el) el.classList.toggle('is-empty', !c.item_count);
        var inner = el && el.querySelector('.drawer__inner'); if (inner) inner.classList.toggle('is-empty', !c.item_count);
      });
    }).catch(function () {});
  }
  function check() {
    if (busy) { again = true; return; }
    busy = true;
    var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var post = function (u, b) { return nativeFetch(u, { method: 'POST', headers: H, body: JSON.stringify(b) }).then(function (r) { return r.json(); }); };
    nativeFetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var u = plan(c.items), bp = planBattery(c.items);
      Object.keys(bp.remove).forEach(function (k) { u[k] = 0; });
      var steps = Promise.resolve(), changed = false;
      if (Object.keys(u).length) { changed = true; steps = steps.then(function () { return post('/cart/update.js', { updates: u }); }); }
      /* Restore before un-noting so the part never sits without labor or note; then edit part notes (each change re-keys only that line). */
      if (bp.add.length) { changed = true; steps = steps.then(function () { return post('/cart/add.js', { items: bp.add }); }); }
      bp.waive.concat(bp.unwaive).forEach(function (w) {
        changed = true; steps = steps.then(function () { return post('/cart/change.js', { id: w.key, quantity: w.quantity, properties: w.properties }); });
      });
      if (!changed) return;
      return steps.then(function () { again = true; }).then(refreshUI);
    }).catch(function () {}).then(function () { busy = false; if (again) { again = false; schedule(); } });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(check, 250); }
  root.ffCartLinkCheck = schedule;

  /* Watch theme cart calls (drawer, cart page, quick add). Our own calls use nativeFetch. */
  root.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(schedule, function () {});
    return p;
  };
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  });
  schedule(); /* page-load check (cart page and every page) */
})(typeof window !== 'undefined' ? window : this);
